/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Pay_LaterInputs */

const en_admin_resource_form_pay_later = /** @type {(inputs: Admin_Resource_Form_Pay_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow visitors to pay later`)
};

const de_admin_resource_form_pay_later = /** @type {(inputs: Admin_Resource_Form_Pay_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besucher können später bezahlen`)
};

const es_admin_resource_form_pay_later = /** @type {(inputs: Admin_Resource_Form_Pay_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir a tus visitantes pagar más tarde`)
};

const fr_admin_resource_form_pay_later = /** @type {(inputs: Admin_Resource_Form_Pay_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permettre aux visiteurs de payer plus tard`)
};

const nl_admin_resource_form_pay_later = /** @type {(inputs: Admin_Resource_Form_Pay_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezoekers later laten betalen`)
};

/** @type {(inputs: Admin_Resource_Form_Pay_LaterInputs) => LocalizedString} */
const it_admin_resource_form_pay_later = en_admin_resource_form_pay_later;

/** @type {(inputs: Admin_Resource_Form_Pay_LaterInputs) => LocalizedString} */
const pt_br2_admin_resource_form_pay_later = en_admin_resource_form_pay_later;

/** @type {(inputs: Admin_Resource_Form_Pay_LaterInputs) => LocalizedString} */
const pl_admin_resource_form_pay_later = en_admin_resource_form_pay_later;

/** @type {(inputs: Admin_Resource_Form_Pay_LaterInputs) => LocalizedString} */
const hu_admin_resource_form_pay_later = en_admin_resource_form_pay_later;

/** @type {(inputs: Admin_Resource_Form_Pay_LaterInputs) => LocalizedString} */
const ro_admin_resource_form_pay_later = en_admin_resource_form_pay_later;

/**
* | output |
* | --- |
* | "Allow visitors to pay later" |
*
* @param {Admin_Resource_Form_Pay_LaterInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_pay_later = /** @type {((inputs?: Admin_Resource_Form_Pay_LaterInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Pay_LaterInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_pay_later(inputs)
	if (locale === "de") return de_admin_resource_form_pay_later(inputs)
	if (locale === "es") return es_admin_resource_form_pay_later(inputs)
	if (locale === "fr") return fr_admin_resource_form_pay_later(inputs)
	if (locale === "nl") return nl_admin_resource_form_pay_later(inputs)
	if (locale === "it") return it_admin_resource_form_pay_later(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_pay_later(inputs)
	if (locale === "pl") return pl_admin_resource_form_pay_later(inputs)
	if (locale === "hu") return hu_admin_resource_form_pay_later(inputs)
	return ro_admin_resource_form_pay_later(inputs)
});
export { admin_resource_form_pay_later as "admin.resource_form.pay_later" }